import { render, staticRenderFns } from "./ApprovedLoans.vue?vue&type=template&id=4a5f1016&scoped=true&"
import script from "./ApprovedLoans.vue?vue&type=script&lang=js&"
export * from "./ApprovedLoans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f1016",
  null
  
)

export default component.exports